import React from "react";
import { Box } from "@mui/material";

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  /** Horizontal breathing room around the 1px visual line — widens the grab target. */
  gutter?: number;
}

/**
 * Vertical drag strip between a list column and its detail pane.
 * Pairs with useResizableListPanel.
 */
const ResizeHandle: React.FC<ResizeHandleProps> = ({
  onMouseDown,
  gutter = 0,
}) => (
  <Box
    onMouseDown={onMouseDown}
    sx={{
      width: `${5 + gutter * 2}px`,
      flexShrink: 0,
      cursor: "col-resize",
      display: "flex",
      justifyContent: "center",
      alignItems: "stretch",
      // Hidden until hover so the divider doesn't add visual noise at rest.
      "&:hover > span": { bgcolor: "primary.main", opacity: 1 },
    }}
  >
    <Box
      component="span"
      sx={{
        width: "3px",
        borderRadius: "2px",
        bgcolor: "divider",
        opacity: 0,
        transition: "opacity 120ms, background-color 120ms",
      }}
    />
  </Box>
);

export default ResizeHandle;
